import { SiteTonnage } from './site-tonnage';
import { SiteAreaData } from './site-area-data';
import { StaffData } from './staff-data';
import { ContractData } from './contract-data';
import { ScaffoldWebAppData } from './scaffold-web-app-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class SiteWebAppData {
  Tonnages: SiteTonnage[];
  SiteId: string;
  Latitude: number;
  Longitude: number;
  SiteAddress: string;
  SiteName: string;
  SiteReference: string;
  SiteStatusId: string;
  NumberOfOpenContracts: number;
  NumberOfActiveCustomerContacts: number;
  HasScaffolds: boolean;
  NumberOfNonDismantledScaffolds: number;
  FirstContractReference: string;
  SiteAreas: { [key: string]: SiteAreaData };
  Staff: StaffData[];
  Customers: string[];
  Contracts: ContractData[];
  Scaffolds: ScaffoldWebAppData[];
  SiteDepotId: string;
  SiteImageUrl: string;
  SiteDepotName: string;
  IsCameraAllowed: boolean;
  IsManageStockControl: boolean;
}


